import { sources } from '../api/sources';

export interface ICardFormHook {
  preFlowHook: Function;
}

class PaymentTokenHelper {
  static initPaymentForm = (firstdata: any, hooks: ICardFormHook, disableCVV?: boolean) => {
    return new Promise((resolve, reject) => {
      try {
        firstdata.createPaymentForm(PaymentTokenHelper.getConfig(disableCVV || false), hooks, resolve);
      } catch (error: any) {
        reject({ error: true, reason: error.message });
      }
    });
  };

  static getConfig = (disableCVV: boolean) => {
    const styles = {
      input: {
        'font-size': '16px',
        color: '#2a282c',
        'font-family': 'Roboto, "Helvetica Neue", Arial, sans-serif',
      },
      '@media screen and (min-width: 768px)': {
        input: {
          'font-size': '18px',
        },
      },
    };
    const classes = {
      empty: 'emptyClass',
      focus: 'focusClass',
      invalid: 'invalidClass',
      valid: 'validClass',
    };
    const fields = {
      card: {
        selector: '#cc-card',
        placeholder: '',
      },
      cvv: disableCVV
        ? undefined
        : {
            selector: '#cc-cvv',
            placeholder: '',
          },
      exp: {
        selector: '#cc-exp',
        placeholder: '',
      },
      name: {
        selector: '#cc-name',
        placeholder: '',
      },
      postalCode: {
        selector: '#cc-zip',
        placeholder: '',
      },
    };

    return { classes, fields, styles };
  };

  static authorizeSession = (manifestId: string) => {
    return sources.authorizeSession({
      id: manifestId,
    });
  };
}

export default PaymentTokenHelper;
